import React, { useEffect } from "react";
import Newnavigation from "../../components/new-navigation/new_navigation";
import PageBanner from "../../components/page-banner/page-banner";
import ContactNew from "../../components/contact-form/ContactNew";
import Footer from "../../components/footer/Footer";
import { WhyChooseTgss } from "../../components/why-choose-tgss/why-choose-tgss";
import PageSmallBanner from "../../components/page-small-banner/page-small-banner";
import KeyServices from "../../components/key-services/KeyServices";
import OurMissions from "../../components/Our-missions/OurMissions";
import ComAccord from "../../components/Accordian/ComAccord";
import WhatweDo from "../../components/what-we-do-img/whatweDo";
import {
  whyChooseTgssDetails,
  EducOurMissons,
  EducationAccord,
  EducationWhatwedo,
  KeyserviceEducation,
} from "../../utils/education";
import { BG7, EDUCATION_BG } from "../../assets/images/index";
import { motion } from "framer-motion";
import HeaderSeo from "../../components/HeaderSeo/Headerseo";
import { EducationSeo } from "../../utils/Seo";

const Education = () => {
  useEffect(() => {
    window.scroll({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 1 } }}
    >
    <div>
      <HeaderSeo data={EducationSeo}/>
      <Newnavigation routeName="Education" />
      <PageBanner
        bg={EDUCATION_BG}
        title="Empowering Education Through Innovative Solutions with Techno Genesis"
        contact="Contact Us"
      />
      <WhatweDo data={EducationWhatwedo} />
      <OurMissions data={EducOurMissons} />
      <KeyServices data={KeyserviceEducation} heading={"Key  Services"} />
      <WhyChooseTgss data={whyChooseTgssDetails} />
      <div className="mt-100 mb-50">
        <PageSmallBanner
          isBtn={true}
          btn_text="Contact Us"
          title="Join us in redefining the landscape of education. Techno Genesis is not just a technology partner; we are your guide to a future where learning knows no bounds."
          bg={BG7}
          height="357px"
        />
      </div>
      <div className="mb-50">
        <ComAccord data={EducationAccord} />
      </div>
      <ContactNew />
      <Footer />
    </div>
    </motion.div>
  );
};
export default Education;
